export class ShowFarmByIdUseCase {
  constructor(repository){
    this.repository=repository
  }
  async execute(id) {
    const resp= await this.repository.showFarmById(id)

    return resp
  }
}
